{% block uc_element_sorter %}
<div class="uc-element-sorter">
    <transition-group name="uc-sorter-list" tag="ul" class="uc-element-sorter__list">
        <li
            v-for="(key, index) in items"
            :key="key"
            class="uc-element-sorter__item"
            :class="{
                'is-disabled':   !isEnabled(key),
                'is-dragging':   dragIndex === index,
                'is-drag-over':  dragOverIndex === index,
            }"
            draggable="true"
            @dragstart="onDragStart(index, $event)"
            @dragover="onDragOver(index, $event)"
            @dragleave="onDragLeave"
            @drop="onDrop(index)"
            @dragend="onDragEnd"
        >
            {# Drag handle #}
            <span class="uc-element-sorter__handle" :title="$tc('sellops-ultimate-cart.elements.dragToReorder')">
                <sw-icon name="regular-bars" size="14px" />
            </span>

            {# Element icon #}
            <span class="uc-element-sorter__icon">
                <sw-icon :name="icon(key)" size="16px" />
            </span>

            {# Label #}
            <span class="uc-element-sorter__label">{{ label(key) }}</span>

            {# Arrow buttons (keyboard fallback) #}
            <div class="uc-element-sorter__arrows">
                <sw-button
                    size="x-small"
                    square
                    :disabled="index === 0"
                    @click="moveUp(index)"
                    :title="$tc('sellops-ultimate-cart.elements.moveUp')"
                >
                    ▲
                </sw-button>
                <sw-button
                    size="x-small"
                    square
                    :disabled="index >= items.length - 1"
                    @click="moveDown(index)"
                    :title="$tc('sellops-ultimate-cart.elements.moveDown')"
                >
                    ▼
                </sw-button>
            </div>

            {# Enable / disable toggle #}
            <sw-switch-field
                :value="isEnabled(key)"
                size="small"
                @change="toggleEnabled(key)"
                class="uc-element-sorter__toggle"
            />
        </li>
    </transition-group>
</div>
{% endblock %}
